import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React, {useCallback, useMemo, useState} from "react";
import Icon from "../icon/icon.component.js";
import {ChipContainer} from "./chip.styles.js";
const activeDeleteIcon = "check_circle_outline";
const activeColor = "secondary";
import {makeStyles} from "../../../../__snowpack__/pkg/@mui/styles.js";
const useStyles = makeStyles({
  chip_flex: {
    height: "auto",
    lineHeight: "24px",
    "& :nth-child(1)": {
      wordBreak: "break-word",
      whiteSpace: "initial !important"
    }
  }
});
function Chip({
  label,
  children,
  translate,
  dataCy,
  variant = "outlined",
  color,
  size,
  readOnly,
  hidden,
  disabled,
  deleteIcon,
  active,
  onDelete,
  onClick
}) {
  const {
    t
  } = useTranslation();
  const [activeState, setActiveState] = useState(active);
  const classes = useStyles();
  const delIcon = useMemo(() => {
    if (deleteIcon) {
      return deleteIcon;
    }
    return activeState !== void 0 ? activeDeleteIcon : void 0;
  }, [activeState, deleteIcon]);
  const canDelete = useMemo(() => {
    if (activeState !== void 0) {
      return activeState;
    }
    return !!onDelete;
  }, [activeState, onDelete]);
  const canClick = useMemo(() => !readOnly && !disabled && (activeState !== void 0 || !!onClick), [activeState, disabled, onClick, readOnly]);
  const _dataCy = useMemo(() => dataCy || translate || children, [children, dataCy, translate]);
  const text = useMemo(() => translate ? t(translate) : label || children || void 0, [children, label, t, translate]);
  const handleDelete = useCallback((e) => {
    if (onDelete && !disabled && !readOnly) {
      onDelete(e);
    }
    if (activeState !== void 0) {
      setActiveState((act) => !act);
    }
  }, [activeState, disabled, onDelete, readOnly]);
  const handleClick = useCallback((e) => {
    if (canDelete) {
      handleDelete(e);
    } else {
      if (onClick && !disabled) {
        onClick(e);
      }
      if (activeState !== void 0) {
        setActiveState((act) => !act);
      }
    }
  }, [activeState, canDelete, disabled, handleDelete, onClick]);
  const getColor = useCallback(() => {
    if (activeState !== void 0) {
      return activeState ? activeColor : "default";
    }
    return color;
  }, [activeState, color]);
  return /* @__PURE__ */ React.createElement(ChipContainer, {
    className: classes.chip_flex,
    "data-cy": _dataCy,
    label: text,
    variant,
    disabled,
    hidden,
    size,
    color: getColor(),
    clickable: !disabled && !!onClick,
    deleteIcon: delIcon ? /* @__PURE__ */ React.createElement(Icon, {
      size: "medium"
    }, delIcon) : void 0,
    onClick: canClick ? handleClick : void 0,
    onDelete: canDelete ? handleDelete : void 0
  });
}
export default Chip;
